import { render } from "./privacy_page.vue?vue&type=template&id=5893938b&scoped=true"
const script = {}

import "./privacy_page.vue?vue&type=style&index=0&id=5893938b&lang=stylus&scoped=true"

import exportComponent from "/Volumes/KINDSTON/Lokal Google Drive/PROJECT/TECHSS/techss/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5893938b"]])

export default __exports__